"use client";
import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {ShopItem, XtgChannle, XtgConfigListResponse} from "@/app/_api/types/store";
import $http from "@/app/_api";
import {useUser} from "@/app/context/UserContext";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {PayWaitingDialogFC} from "@/app/_dialogs/PayWaitingDialog/PayWaitingDialog";
import styles from "./PaySelectionDialog.module.css";
import PayUtil from "@/Core/Pay/PayUtil";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import Util from "@/Master/Util";
import {PayIOSTipsDialogFC} from "@/app/_dialogs/PayIOSTipsDialog/PayIOSTipsDialog";

interface PaySelectionDialogProps extends SDialogProps {
    data: XtgConfigListResponse;
    shopItem: ShopItem;
}

export const PaySelectionDialogFC: React.FC<PaySelectionDialogProps> = (props) => {
    const { fcKey, isOpen, data, shopItem } = props;
    if (!isOpen) return null;

    const user = useUser();
    const onClickOpenPaymentLink = async (row: XtgChannle) => {
        showForceLoading();
        const responseData = await $http.Store.getXtgLink({
            channel: row.pay_type,
            extraInfo: {
                itemsId: shopItem.id,
                itemsType: shopItem.itemsType,
                ks: data.ks,
                payAmount: shopItem.money,
                productId: shopItem.productId,
                userId: user.userId,
            },
            platformOrderId: data.ks,
            sessionId: data.session_id,
        });
        hideForceLoading();

        if (responseData?.xtg_link){
            if (Util.isIOS){
                SDialogManagerFC.openDialog(PayIOSTipsDialogFC,{
                    fcKey: SDialogManagerFC.getFCKey(PayIOSTipsDialogFC),
                    onClose:()=>{
                        openPayLink(responseData.xtg_link, row.pay_type);
                    }
                });
            }else{
                openPayLink(responseData.xtg_link, row.pay_type);
            }
        }
    };

    const openPayLink = (xtg_link: string, pay_type: string) => {
        if (!xtg_link) {
            return;
        }
        window.open(xtg_link);
        SDialogManagerFC.closeDialog(fcKey);
        SDialogManagerFC.openDialog(PayWaitingDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(PayWaitingDialogFC),
            ks: data.ks,
            pType: pay_type,
            shopItem: shopItem,
        });
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title={
                <p style={{ marginBottom: ".4rem", fontSize: ".6rem", fontWeight: "bold" }}>
                    CHOOSE A DEPOSIT WAY
                </p>
            }
            bottom={
                <div className={styles.footer}>
                    <img className={styles.icon_left} src="/img/payment-selection/icon_left.webp" alt="" />
                    <div className={styles.footer_font}>Secure and Fast</div>
                    <img className={styles.icon_right} src="/img/payment-selection/icon_right.webp" alt="" />
                </div>
            }
        >
            <section className={styles.content}>
                <section className={styles.payment_list_wrapper}>
                    {data.channel.map((item, index) => (
                        <section
                            key={index}
                            className={`${styles.payment_list_item} btn`}
                            onClick={() => onClickOpenPaymentLink(item)}
                        >
                            <img
                                src={`/img/pay/item/${PayUtil.getPayChannelName(item.attribution)}`}
                                alt={item.atr_label}
                            />
                            {/*<span style={{color: '#333'}}>{item.atr_label}</span>*/}
                        </section>
                    ))}
                </section>
            </section>
        </SDialogFC>
    );
};
